<template>
  <v-btn
    @click="install"
    target="_blank"
    size="large"
    color="accent"
    href="https://chrome.google.com/webstore/detail/lipsurf/lnnmjmalakahagblkkcnjkoaihlfglon"
  >
    <span>{{primary}}</span>
  </v-btn>
</template>

<script lang="ts" setup>

const props = defineProps({
  primary: {
    type: String,
    default: "Add to Chrome ➜",
  },
  secondary: {
    type: String,
    default: "- it's free"
  },
});

function install() {
  // @ts-ignore
  window.gtag("event", "click install button", {
    event_category: "install",
  });
}
</script>
